import Layout from '../../../components/Layout';
import MyAccountSubMenu from '../../../components/MyAccountSubMenu';
import TalkableWidget from '../../../components/TalkableWidget';
import './Dashboard.css';

const Dashboard = () => (
  <Layout pageTitle="My Account - FabFitFun" isProtected>
    <MyAccountSubMenu />
    <h1 className="dashboard__title">My referrals</h1>
    <div className="pageContent">
      <TalkableWidget />
    </div>
  </Layout>
);

export default Dashboard;
